import { breakpointsTailwind } from "@vueuse/core";

export const useProductListingView = createSharedComposable(() => {
	const breakPoints = useBreakpoints(breakpointsTailwind);
	const renderMode = ref<"single" | "double">("single");

	watch(breakPoints.greaterOrEqual("md"), (isLarger) => {
		if (isLarger) {
			renderMode.value = "single";
		}
	});

	return {
		renderMode
	};
});
